import styled from 'styled-components'
import { Scroller } from '@ta-interaktiv/react-scroller'
import { useWindowSize } from 'usehooks-ts'
import { useEffect, useState } from 'react'
import { AnnotatedImage } from 'components/AnnotatedImage'
import ImageCollection from 'components/ImageCollection'
import { ColorKey } from 'components/ColorKey'
import { getColorKeyEntries } from 'Content/CityDatas/sat_images/color_key_entries'

const opacities = [
  [1, 1, 1, 1, 1],
  [0.25, 0.25, 0.25, 1, 1],
  [1, 1, 0.25, 0.25, 0.25],
]
const City = ({
  cityData,
  lables,
  colorMode,
  lang,
}: {
  cityData: CityData
  lables: any
  colorMode: 'light' | 'dark' | undefined
  lang: 'de' | 'fr'
}) => {
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  const dm = colorMode === 'dark'
  const [height, setHeight] = useState(0)

  useEffect(() => {
    setHeight(windowSize.height)
  }, [windowSize.width, isMobile])

  useEffect(() => {
    setHeight(windowSize.height + 30)
  }, [])

  return (
    <CityContainer height={height}>
      <Scroller
        front={[
          ...cityData.elements.map((el, i) => {
            return (
            <FrontElement id={el.id} distanceBottom={height * 0.8} key={"frontelement_"+i}>
                {el.text}
              </FrontElement>
            )
          }),
          <FrontElementWide distanceBottom={0} distanceTop={0}>
            {cityData.sat_images && (
              <ImageCollection
                colorMode={colorMode}
                labels={lables}
                lang={lang}
                text={
                  <>
                    <Text>{lables.sat_title}</Text>
                  </>
                }
                entries={[
                  {
                    label: cityData.sat_images[0].label,
                    image: cityData.sat_images[0].image,
                  },
                  {
                    label: cityData.sat_images[1].label,
                    image: cityData.sat_images[1].image,
                  },
                ]}
              />
            )}
          </FrontElementWide>,
        ]}
        back={(index: number, id: string) => {
          const opas = opacities[index]
            ? opacities[index]
            : opacities[opacities.length - 1]

          // const img = images[id]
          //   ? images[id]
          //   : images[cityData.elements[cityData.elements.length - 1].id]

          const elements: any = cityData.elements[index]
            ? cityData.elements[index]
            : cityData.elements[cityData.elements.length - 1]

          return (
            <Back style={{ height: '100%' }}>
              <Center>
                <TitleContainer>
                  <CityTitle style={{ top: height * 0.1 + 'px' }}>
                    {cityData.name}
                  </CityTitle>
                  <ColorKey
                    centered
                    entries={
                      getColorKeyEntries(colorMode, lang, false, opas) as any
                    }
                  />
                </TitleContainer>
                <ImageContainer>
                  {elements && (
                    <AnnotatedImage
                      img={dm ? elements.image_dm : elements.image}
                      annotations={(
                        elements.annotations || ([] as CityAnnotation[])
                      )
                        .filter((f: any) =>
                          isMobile ? f.position_mobile : f.position
                        )
                        .map((m: any) => ({
                          content: m.content,
                          position: !m.position_mobile
                            ? m.position
                            : isMobile
                            ? m.position_mobile
                            : m.position,
                        }))}
                    />
                  )}
                </ImageContainer>
              </Center>
            </Back>
          )
        }}
      />{' '}
      {/* {cityData && cityData.sat_images && (
        <ImageCollection
          labels={lables}
          text={
            <>
              <Text>{lables.sat_title}</Text>
            </>
          }
          entries={[
            {
              label: cityData.sat_images[0].label,
              image: cityData.sat_images[0].image,
            },
            {
              label: cityData.sat_images[1].label,
              image: cityData.sat_images[1].image,
            },
          ]}
        />
      )} */}
    </CityContainer>
  )
}
const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
`

const Text = styled.div`
  flex: 0 0 100%;
  font-family: var(--font-sans-serif);
  font-weight: 700;
  line-height: 1.3em;
  @media screen and (max-width: 712px) {
    font-size: 15px;
  }
`

const TitleContainer = styled.div`
  width: calc(100% - 30px);
  display: flex;
  align-items: baseline;
  padding-left: 15px;
  padding-right: 15px;
  /* border-bottom: 1px solid var(--city-title-border); */
  padding-bottom: 10px;
  padding: 10px;
  * {
    align-items: center;
  }
  @media screen and (max-width: 712px) {
    margin-top: 70px;
    display: flex;
    border: 0;
  }
`

const CityContainer = styled.div<{ height: number }>`
  max-width: 100%;
  margin-bottom: 90px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  /* -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0); */
  .colorkey {
    width: 100%;
    justify-content: center;
  }
  .back {
    position: sticky;
    top: 0;

    z-index: 0;
    height: ${(props) => props.height * 1}px;
  }
  .front {
    line-height: 0;
    position: relative;
    z-index: 10;
  }
  @media screen and (max-width: 712px) {
    margin-bottom: 30px;
  }
`

const CityTitle = styled.div`
  font-family: var(--font-serif);
  display: inline-block;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 0.3px;
  /* width: 100%; */
  text-align: left;
  /* margin-top: 30px; */
  padding: 0;
  flex: 1 1 10%;
  min-width: 200px;

  @media screen and (max-width: 712px) {
    width: unset;
    min-width: unset;
    margin-top: 0px;
    font-size: 22px;
  }
`
const Back = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100%;
  position: relative;
  flex-wrap: wrap;
  justify-content: center;

  img {
    max-height: 100vh;
  }
`
const ImageContainer = styled.div`
  /* align-self: flex-start; */
`
const FrontElement = styled.div<{
  distanceTop?: number
  distanceBottom?: number
}>`
  z-index: 100;
  /* transform: translate3d(0, 0, 0); */
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  background-color: var(--front-element-bg);
  max-width: 668px;
  margin-left: auto;
  margin-right: auto;
  padding: 15px 30px;
  font-size: 18px;
  font-family: var(--font-serif);
  line-height: 1.6em;

  @media screen and (max-width: 712px) {
    font-size: 15px;
    line-height: 26px;
  }
`
const FrontElementWide = styled.div<{
  distanceTop?: number
  distanceBottom?: number
}>`
  line-height: 1.6em;
  background-color: var(--site-background);
  /* -webkit-transform: translate3d(0, 0, 0); */
  /* transform: translate3d(0, 0, 0); */
  padding: 15px 0 15px 0px;
  font-size: 18px;
  font-family: var(--font-serif);

  @media screen and (max-width: 712px) {
    padding: 15px 15px;
    font-size: 15px;
    line-height: 26px;
  }
`
export default City
